import { render, staticRenderFns } from "./ClienteSolicitudIndex.vue?vue&type=template&id=20f7bf74&"
import script from "./ClienteSolicitudIndex.vue?vue&type=script&lang=js&"
export * from "./ClienteSolicitudIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports